// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__265LK"};